import { useMemo } from 'react'
import Stack from '@mui/material/Stack'
import { useParams } from 'react-router-dom'
import { useFormContext } from 'react-hook-form'

import { getEventDetails } from '../../../../store.slice'
import { useAppSelector } from '../../../../store'
import {
  ModifySubEventsSchema,
  ModifyEventWihtoutOptionsSchema,
} from '../../../events/Events.schema'
import TimeGridCalendar from '../../../events/view/components/TimeGridCalendar'
import { ErrorParsingDataCalendar } from '../CreateEvent.components'

export default function Step2CalendarView() {
  const { eventId } = useParams()
  if (!eventId) {
    throw new Error('eventId is required')
  }

  const eventDetails = useAppSelector(state => getEventDetails(state)(eventId))

  const { watch } = useFormContext<ModifySubEventsSchema>()
  const sessions = watch('sessions')
  const subEvents = watch('subEvents')

  const data = useMemo(() => {
    const dataToParse = {
      ...eventDetails,
      sessions: sessions,
      subEvents: subEvents,
    }
    try {
      const res = ModifyEventWihtoutOptionsSchema.safeParse(dataToParse)
      return res
    } catch (e) {
      console.error(e)
      return null
    }
  }, [eventDetails, sessions, subEvents])

  return (
    <Stack spacing={1} alignItems="center">
      {data && 'data' in data && data.success ? (
        <TimeGridCalendar
          data={data.data}
          showHiddenFromGenericProgram
          showWithoutSession
          showHotel
        />
      ) : (
        <ErrorParsingDataCalendar data={data} />
      )}
    </Stack>
  )
}
